import script from "./BaseHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseHeader.vue?vue&type=script&lang=ts&setup=true"

import "./BaseHeader.vue?vue&type=style&index=0&id=0f8359d0&lang=scss"

const __exports__ = script;

export default __exports__